import React from "react"

// https://commons.wikimedia.org/wiki/File:External.svg
const External = ({ to, className, children }) => {
	className = className ? className : ""
	return (
		<a className={className} target="_blank" rel="noopener noreferrer" href={to}>
			{children}
		</a>
	)
}

export default External
